import axios from '@/services/ProductService/productInstance';

interface SectionData {
    [key: string]: any;
}

const CreateSections = async (section: SectionData): Promise<number> => {
    return new Promise((resolve, reject) => {
        axios
        .post('/sections/', section)
        .then(res => resolve(res?.data?.id))
        .catch(err => reject(err));
    });
};

export default CreateSections;